function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 94,
  width: 358,
  height: 17,
  fill: "#2A6EBF"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  y: 402,
  width: 537,
  height: 9,
  fill: "#2A6EBF"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 90,
  y: 411,
  width: 366,
  height: 9,
  fill: "#2A6EBF"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M371.778 172.374H358.571V182.67H348.667V227.532H332.984V262.833H314V379.032H418V262.833H398.19V227.532H382.508V182.67H371.778V172.374Z",
  fill: "#F7FAFF"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 344.062,
  y: 272.708,
  width: 8.9375,
  height: 8.23637,
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 344.062,
  y: 272.708,
  width: 8.9375,
  height: 8.23637,
  fill: "white"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 344.062,
  y: 272.708,
  width: 8.9375,
  height: 8.23637,
  fill: "white"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 360.312,
  y: 272.708,
  width: 8.9375,
  height: 8.23637,
  fill: "white"
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 360.312,
  y: 272.708,
  width: 8.9375,
  height: 8.23637,
  fill: "white"
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  x: 360.312,
  y: 272.708,
  width: 8.9375,
  height: 8.23637,
  fill: "white"
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  x: 377.375,
  y: 272.708,
  width: 8.9375,
  height: 8.23637,
  fill: "white"
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  x: 377.375,
  y: 272.708,
  width: 8.9375,
  height: 8.23637,
  fill: "white"
});

var _ref14 = /*#__PURE__*/React.createElement("rect", {
  x: 377.375,
  y: 272.708,
  width: 8.9375,
  height: 8.23637,
  fill: "white"
});

var _ref15 = /*#__PURE__*/React.createElement("rect", {
  x: 344.062,
  y: 287.683,
  width: 8.9375,
  height: 8.23637,
  fill: "white"
});

var _ref16 = /*#__PURE__*/React.createElement("rect", {
  x: 344.062,
  y: 287.683,
  width: 8.9375,
  height: 8.23637,
  fill: "white"
});

var _ref17 = /*#__PURE__*/React.createElement("rect", {
  x: 344.062,
  y: 287.683,
  width: 8.9375,
  height: 8.23637,
  fill: "white"
});

var _ref18 = /*#__PURE__*/React.createElement("rect", {
  x: 360.312,
  y: 287.683,
  width: 8.9375,
  height: 8.23637,
  fill: "white"
});

var _ref19 = /*#__PURE__*/React.createElement("rect", {
  x: 360.312,
  y: 287.683,
  width: 8.9375,
  height: 8.23637,
  fill: "white"
});

var _ref20 = /*#__PURE__*/React.createElement("rect", {
  x: 360.312,
  y: 287.683,
  width: 8.9375,
  height: 8.23637,
  fill: "white"
});

var _ref21 = /*#__PURE__*/React.createElement("rect", {
  x: 377.375,
  y: 287.683,
  width: 8.9375,
  height: 8.23637,
  fill: "white"
});

var _ref22 = /*#__PURE__*/React.createElement("rect", {
  x: 377.375,
  y: 287.683,
  width: 8.9375,
  height: 8.23637,
  fill: "white"
});

var _ref23 = /*#__PURE__*/React.createElement("rect", {
  x: 377.375,
  y: 287.683,
  width: 8.9375,
  height: 8.23637,
  fill: "white"
});

var _ref24 = /*#__PURE__*/React.createElement("rect", {
  x: 344.062,
  y: 242.758,
  width: 8.9375,
  height: 8.23637,
  fill: "white"
});

var _ref25 = /*#__PURE__*/React.createElement("rect", {
  x: 344.062,
  y: 242.758,
  width: 8.9375,
  height: 8.23637,
  fill: "white"
});

var _ref26 = /*#__PURE__*/React.createElement("rect", {
  x: 344.062,
  y: 242.758,
  width: 8.9375,
  height: 8.23637,
  fill: "white"
});

var _ref27 = /*#__PURE__*/React.createElement("rect", {
  x: 360.312,
  y: 242.758,
  width: 8.9375,
  height: 8.23637,
  fill: "white"
});

var _ref28 = /*#__PURE__*/React.createElement("rect", {
  x: 360.312,
  y: 242.758,
  width: 8.9375,
  height: 8.23637,
  fill: "white"
});

var _ref29 = /*#__PURE__*/React.createElement("rect", {
  x: 360.312,
  y: 242.758,
  width: 8.9375,
  height: 8.23637,
  fill: "white"
});

var _ref30 = /*#__PURE__*/React.createElement("rect", {
  x: 377.375,
  y: 242.758,
  width: 8.9375,
  height: 8.23637,
  fill: "white"
});

var _ref31 = /*#__PURE__*/React.createElement("rect", {
  x: 377.375,
  y: 242.758,
  width: 8.9375,
  height: 8.23637,
  fill: "white"
});

var _ref32 = /*#__PURE__*/React.createElement("rect", {
  x: 377.375,
  y: 242.758,
  width: 8.9375,
  height: 8.23637,
  fill: "white"
});

var _ref33 = /*#__PURE__*/React.createElement("rect", {
  x: 344.062,
  y: 257.733,
  width: 8.9375,
  height: 8.23637,
  fill: "white"
});

var _ref34 = /*#__PURE__*/React.createElement("rect", {
  x: 344.062,
  y: 257.733,
  width: 8.9375,
  height: 8.23637,
  fill: "white"
});

var _ref35 = /*#__PURE__*/React.createElement("rect", {
  x: 344.062,
  y: 257.733,
  width: 8.9375,
  height: 8.23637,
  fill: "white"
});

var _ref36 = /*#__PURE__*/React.createElement("rect", {
  x: 360.312,
  y: 257.733,
  width: 8.9375,
  height: 8.23637,
  fill: "white"
});

var _ref37 = /*#__PURE__*/React.createElement("rect", {
  x: 360.312,
  y: 257.733,
  width: 8.9375,
  height: 8.23637,
  fill: "white"
});

var _ref38 = /*#__PURE__*/React.createElement("rect", {
  x: 360.312,
  y: 257.733,
  width: 8.9375,
  height: 8.23637,
  fill: "white"
});

var _ref39 = /*#__PURE__*/React.createElement("rect", {
  x: 377.375,
  y: 257.733,
  width: 8.9375,
  height: 8.23637,
  fill: "white"
});

var _ref40 = /*#__PURE__*/React.createElement("rect", {
  x: 377.375,
  y: 257.733,
  width: 8.9375,
  height: 8.23637,
  fill: "white"
});

var _ref41 = /*#__PURE__*/React.createElement("rect", {
  x: 377.375,
  y: 257.733,
  width: 8.9375,
  height: 8.23637,
  fill: "white"
});

var _ref42 = /*#__PURE__*/React.createElement("rect", {
  x: 344.062,
  y: 302.658,
  width: 8.9375,
  height: 8.23637,
  fill: "white"
});

var _ref43 = /*#__PURE__*/React.createElement("rect", {
  x: 344.062,
  y: 302.658,
  width: 8.9375,
  height: 8.23637,
  fill: "white"
});

var _ref44 = /*#__PURE__*/React.createElement("rect", {
  x: 344.062,
  y: 302.658,
  width: 8.9375,
  height: 8.23637,
  fill: "white"
});

var _ref45 = /*#__PURE__*/React.createElement("rect", {
  x: 360.312,
  y: 302.658,
  width: 8.9375,
  height: 8.23637,
  fill: "white"
});

var _ref46 = /*#__PURE__*/React.createElement("rect", {
  x: 360.312,
  y: 302.658,
  width: 8.9375,
  height: 8.23637,
  fill: "white"
});

var _ref47 = /*#__PURE__*/React.createElement("rect", {
  x: 360.312,
  y: 302.658,
  width: 8.9375,
  height: 8.23637,
  fill: "white"
});

var _ref48 = /*#__PURE__*/React.createElement("rect", {
  x: 377.375,
  y: 302.658,
  width: 8.9375,
  height: 8.23637,
  fill: "white"
});

var _ref49 = /*#__PURE__*/React.createElement("rect", {
  x: 377.375,
  y: 302.658,
  width: 8.9375,
  height: 8.23637,
  fill: "white"
});

var _ref50 = /*#__PURE__*/React.createElement("rect", {
  x: 377.375,
  y: 302.658,
  width: 8.9375,
  height: 8.23637,
  fill: "white"
});

var _ref51 = /*#__PURE__*/React.createElement("rect", {
  x: 344.062,
  y: 317.634,
  width: 8.9375,
  height: 8.23637,
  fill: "white"
});

var _ref52 = /*#__PURE__*/React.createElement("rect", {
  x: 344.062,
  y: 317.634,
  width: 8.9375,
  height: 8.23637,
  fill: "white"
});

var _ref53 = /*#__PURE__*/React.createElement("rect", {
  x: 344.062,
  y: 317.634,
  width: 8.9375,
  height: 8.23637,
  fill: "white"
});

var _ref54 = /*#__PURE__*/React.createElement("rect", {
  x: 360.312,
  y: 317.634,
  width: 8.9375,
  height: 8.23637,
  fill: "white"
});

var _ref55 = /*#__PURE__*/React.createElement("rect", {
  x: 360.312,
  y: 317.634,
  width: 8.9375,
  height: 8.23637,
  fill: "white"
});

var _ref56 = /*#__PURE__*/React.createElement("rect", {
  x: 360.312,
  y: 317.634,
  width: 8.9375,
  height: 8.23637,
  fill: "white"
});

var _ref57 = /*#__PURE__*/React.createElement("rect", {
  x: 377.375,
  y: 317.634,
  width: 8.9375,
  height: 8.23637,
  fill: "white"
});

var _ref58 = /*#__PURE__*/React.createElement("rect", {
  x: 377.375,
  y: 317.634,
  width: 8.9375,
  height: 8.23637,
  fill: "white"
});

var _ref59 = /*#__PURE__*/React.createElement("rect", {
  x: 377.375,
  y: 317.634,
  width: 8.9375,
  height: 8.23637,
  fill: "white"
});

var _ref60 = /*#__PURE__*/React.createElement("rect", {
  x: 344.062,
  y: 331.86,
  width: 8.9375,
  height: 8.23637,
  fill: "white"
});

var _ref61 = /*#__PURE__*/React.createElement("rect", {
  x: 344.062,
  y: 331.86,
  width: 8.9375,
  height: 8.23637,
  fill: "white"
});

var _ref62 = /*#__PURE__*/React.createElement("rect", {
  x: 344.062,
  y: 331.86,
  width: 8.9375,
  height: 8.23637,
  fill: "white"
});

var _ref63 = /*#__PURE__*/React.createElement("rect", {
  x: 360.312,
  y: 331.86,
  width: 8.9375,
  height: 8.23637,
  fill: "white"
});

var _ref64 = /*#__PURE__*/React.createElement("rect", {
  x: 360.312,
  y: 331.86,
  width: 8.9375,
  height: 8.23637,
  fill: "white"
});

var _ref65 = /*#__PURE__*/React.createElement("rect", {
  x: 360.312,
  y: 331.86,
  width: 8.9375,
  height: 8.23637,
  fill: "white"
});

var _ref66 = /*#__PURE__*/React.createElement("rect", {
  x: 377.375,
  y: 331.86,
  width: 8.9375,
  height: 8.23637,
  fill: "white"
});

var _ref67 = /*#__PURE__*/React.createElement("rect", {
  x: 377.375,
  y: 331.86,
  width: 8.9375,
  height: 8.23637,
  fill: "white"
});

var _ref68 = /*#__PURE__*/React.createElement("rect", {
  x: 377.375,
  y: 331.86,
  width: 8.9375,
  height: 8.23637,
  fill: "white"
});

var _ref69 = /*#__PURE__*/React.createElement("rect", {
  x: 344.062,
  y: 346.835,
  width: 8.9375,
  height: 8.23637,
  fill: "white"
});

var _ref70 = /*#__PURE__*/React.createElement("rect", {
  x: 344.062,
  y: 346.835,
  width: 8.9375,
  height: 8.23637,
  fill: "white"
});

var _ref71 = /*#__PURE__*/React.createElement("rect", {
  x: 344.062,
  y: 346.835,
  width: 8.9375,
  height: 8.23637,
  fill: "white"
});

var _ref72 = /*#__PURE__*/React.createElement("rect", {
  x: 360.312,
  y: 346.835,
  width: 8.9375,
  height: 8.23637,
  fill: "white"
});

var _ref73 = /*#__PURE__*/React.createElement("rect", {
  x: 360.312,
  y: 346.835,
  width: 8.9375,
  height: 8.23637,
  fill: "white"
});

var _ref74 = /*#__PURE__*/React.createElement("rect", {
  x: 360.312,
  y: 346.835,
  width: 8.9375,
  height: 8.23637,
  fill: "white"
});

var _ref75 = /*#__PURE__*/React.createElement("rect", {
  x: 377.375,
  y: 346.835,
  width: 8.9375,
  height: 8.23637,
  fill: "white"
});

var _ref76 = /*#__PURE__*/React.createElement("rect", {
  x: 377.375,
  y: 346.835,
  width: 8.9375,
  height: 8.23637,
  fill: "white"
});

var _ref77 = /*#__PURE__*/React.createElement("rect", {
  x: 377.375,
  y: 346.835,
  width: 8.9375,
  height: 8.23637,
  fill: "white"
});

var _ref78 = /*#__PURE__*/React.createElement("rect", {
  x: 344.062,
  y: 361.062,
  width: 8.9375,
  height: 8.23637,
  fill: "white"
});

var _ref79 = /*#__PURE__*/React.createElement("rect", {
  x: 344.062,
  y: 361.062,
  width: 8.9375,
  height: 8.23637,
  fill: "white"
});

var _ref80 = /*#__PURE__*/React.createElement("rect", {
  x: 344.062,
  y: 361.062,
  width: 8.9375,
  height: 8.23637,
  fill: "white"
});

var _ref81 = /*#__PURE__*/React.createElement("rect", {
  x: 360.312,
  y: 361.062,
  width: 8.9375,
  height: 8.23637,
  fill: "white"
});

var _ref82 = /*#__PURE__*/React.createElement("rect", {
  x: 360.312,
  y: 361.062,
  width: 8.9375,
  height: 8.23637,
  fill: "white"
});

var _ref83 = /*#__PURE__*/React.createElement("rect", {
  x: 360.312,
  y: 361.062,
  width: 8.9375,
  height: 8.23637,
  fill: "white"
});

var _ref84 = /*#__PURE__*/React.createElement("rect", {
  x: 377.375,
  y: 361.062,
  width: 8.9375,
  height: 8.23637,
  fill: "white"
});

var _ref85 = /*#__PURE__*/React.createElement("rect", {
  x: 377.375,
  y: 361.062,
  width: 8.9375,
  height: 8.23637,
  fill: "white"
});

var _ref86 = /*#__PURE__*/React.createElement("rect", {
  x: 377.375,
  y: 361.062,
  width: 8.9375,
  height: 8.23637,
  fill: "white"
});

var _ref87 = /*#__PURE__*/React.createElement("rect", {
  x: 108.5,
  y: 13.5,
  width: 329,
  height: 391,
  stroke: "#2A6EBF",
  strokeWidth: 5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref88 = /*#__PURE__*/React.createElement("path", {
  d: "M380.359 362.894C375.086 367.375 365.648 378.241 368.928 376.512C378.021 371.712 383.515 375.152 384.373 386H354.999C354.999 386 358.447 370.57 352.947 369.312C347.048 367.959 350.918 358.259 345.034 356.962C339.151 355.665 351.041 345.925 351.041 345.925L391.713 349.491C391.713 349.491 388.925 355.617 380.359 362.894Z",
  fill: "#29ABE2"
});

var _ref89 = /*#__PURE__*/React.createElement("path", {
  d: "M328.722 365.008C334.225 369.202 337.516 376.241 334.832 374.946C325.437 370.408 319.386 375.211 321.994 385.746H350.746C350.746 385.746 347.249 372.972 351.305 369.058C356.554 363.991 350.22 363.769 356.104 362.472C361.989 361.175 353.041 345.669 353.041 345.669L317.657 351.023C317.657 351.023 319.764 358.184 328.722 365.008Z",
  fill: "#29ABE2"
});

var _ref90 = /*#__PURE__*/React.createElement("path", {
  d: "M382.174 267.662C376.539 263.678 371.225 258.422 367.833 251.756C367.194 253.398 367.671 255.246 368.153 256.904C364.82 252 363.863 248.751 361.099 243.226C360.348 246.792 359.703 248.635 359.168 253.04C353.954 250.073 349.3 242.1 343.605 240C345.563 242.995 347.508 245.971 349.119 249.136C345.5 247.182 341.898 245.123 338.313 242.958C340.728 246.871 343.191 250.956 343.611 255.532L336.269 250.99C337.366 252.391 338.149 254.011 338.564 255.74L331.986 254.891C333.734 257.141 334.594 259.953 334.403 262.793C350.08 268.385 366.818 267.814 382.8 270.667L380.762 268.992",
  fill: "#29ABE2"
});

var _ref91 = /*#__PURE__*/React.createElement("path", {
  d: "M299.707 291.52C301.363 298.691 308.109 303.56 314.832 302.55C321.579 301.536 325.987 294.955 324.637 287.689C323.246 280.238 316.356 274.96 309.304 276.07C302.278 277.175 298.004 284.167 299.707 291.52Z",
  fill: "#29ABE2"
});

var _ref92 = /*#__PURE__*/React.createElement("path", {
  d: "M304.207 291.777C305.351 296.899 309.8 300.452 314.172 299.792C318.544 299.131 320.834 291.781 319.82 286.567C318.786 281.258 314.767 280.291 310.238 280.994C305.709 281.697 303.043 286.565 304.207 291.777Z",
  fill: "#FCEE21"
});

var _ref93 = /*#__PURE__*/React.createElement("path", {
  d: "M381.07 293.668C381.761 301.28 388.22 306.439 395.525 305.365C402.865 304.292 408.569 297.311 408.233 289.593C407.889 281.666 401.337 276.043 393.636 277.224C385.965 278.406 380.359 285.852 381.07 293.668Z",
  fill: "#29ABE2"
});

var _ref94 = /*#__PURE__*/React.createElement("path", {
  d: "M403.718 289.906C403.987 295.146 400.509 299.869 395.963 300.539C391.417 301.21 387.166 294.915 386.745 289.669C386.315 284.329 390.024 282.185 394.709 281.47C399.394 280.756 403.445 284.571 403.718 289.906Z",
  fill: "#FCEE21"
});

var _ref95 = /*#__PURE__*/React.createElement("path", {
  d: "M305.772 321.018C308.376 351.098 329.655 373.171 353.556 373.171C377.457 373.171 398.755 351.098 401.38 321.018C404.328 287.241 383.095 256.656 353.599 256.656C324.103 256.656 302.849 287.241 305.772 321.018Z",
  fill: "#29ABE2"
});

var _ref96 = /*#__PURE__*/React.createElement("path", {
  d: "M310.347 317.318C312.553 343.059 331.678 361.876 353.279 361.434C374.915 360.99 393.795 341.333 395.557 315.419C397.5 286.84 378.243 261.93 352.403 262.564C326.619 263.194 307.916 288.939 310.347 317.318Z",
  fill: "#31CAFF"
});

var _ref97 = /*#__PURE__*/React.createElement("path", {
  d: "M368.38 307.704C366.251 310.932 362.26 312.168 358.636 312.815C354.733 313.509 350.627 313.528 346.789 312.484C344.636 311.904 342.605 310.944 340.792 309.648C340.393 309.363 340.013 310.02 340.408 310.304C343.776 312.729 347.858 313.85 351.971 314.034C356.004 314.212 360.355 313.658 364.077 312.046C366.065 311.19 367.837 309.906 369.038 308.086C369.309 307.677 368.649 307.296 368.38 307.704V307.704Z",
  fill: "#002E47"
});

var _ref98 = /*#__PURE__*/React.createElement("path", {
  d: "M371.455 308.148C370.964 308.267 370.449 308.239 369.974 308.067C369.499 307.896 369.085 307.587 368.785 307.182C368.486 306.795 367.95 307.337 368.246 307.718C368.641 308.22 369.173 308.596 369.778 308.802C370.382 309.008 371.034 309.035 371.654 308.879C372.13 308.764 371.929 308.031 371.451 308.148H371.455Z",
  fill: "#002E47"
});

var _ref99 = /*#__PURE__*/React.createElement("path", {
  d: "M340.342 309.055C340.146 309.315 339.869 309.504 339.554 309.591C339.239 309.678 338.904 309.659 338.601 309.537C338.157 309.341 337.769 309.996 338.217 310.193C338.665 310.4 339.169 310.453 339.651 310.345C340.133 310.236 340.566 309.972 340.881 309.592C341.184 309.214 340.648 308.674 340.342 309.055V309.055Z",
  fill: "#002E47"
});

var _ref100 = /*#__PURE__*/React.createElement("path", {
  d: "M324.114 297.61C324.243 299.442 325.31 300.899 326.498 300.875C327.687 300.85 328.558 299.354 328.443 297.521C328.329 295.688 327.259 294.192 326.057 294.216C324.854 294.24 323.986 295.771 324.114 297.61Z",
  fill: "#002E47"
});

var _ref101 = /*#__PURE__*/React.createElement("path", {
  d: "M377.038 296.668C376.998 298.507 377.932 299.969 379.125 299.949C380.318 299.929 381.329 298.423 381.383 296.584C381.437 294.745 380.503 293.243 379.298 293.269C378.092 293.295 377.08 294.818 377.038 296.668Z",
  fill: "#002E47"
});

var _ref102 = /*#__PURE__*/React.createElement("path", {
  d: "M397.154 360.197C396.432 360.707 395.594 361.03 394.715 361.138C393.837 361.245 392.945 361.134 392.12 360.813C390.481 360.157 389.156 359.37 388.84 357.638C388.669 356.708 388.927 355.831 389.708 355.295C390.623 355.283 390.862 355.363 391.585 355.648C392.309 355.934 393.194 355.934 393.804 355.453C394.413 354.972 394.6 354.186 394.989 353.537C395.378 352.888 399.565 351.609 399.565 351.609C404.165 337.411 404.341 330.146 397.482 316.881L398.696 303.901C405.5 310.163 409.154 319.306 410.137 328.49C411.119 337.675 409.552 344.821 407.348 353.791",
  fill: "#29ABE2"
});

var _ref103 = /*#__PURE__*/React.createElement("path", {
  d: "M396.865 359.703C396.169 360.19 395.358 360.488 394.512 360.569C393.665 360.65 392.812 360.511 392.036 360.166C390.816 359.646 389.619 358.899 389.392 357.487C389.272 356.744 389.503 355.765 390.411 355.888C391.106 355.982 391.698 356.369 392.413 356.407C393.059 356.456 393.699 356.26 394.204 355.857C394.795 355.36 394.999 354.646 395.378 354.002C395.714 353.432 396.951 353.101 397.642 352.851C398.333 352.602 399.052 352.448 399.704 352.158C400.283 351.9 400.342 351.04 400.514 350.493C400.8 349.571 401.078 348.645 401.349 347.716C401.799 346.139 402.207 344.548 402.543 342.942C403.708 337.349 403.706 331.748 402.05 326.254C401.104 323.116 399.761 320.108 398.275 317.191C398.122 316.888 398.08 316.974 398.064 316.726C398.068 316.531 398.086 316.337 398.118 316.145L398.313 314.067L399.268 303.901L398.291 304.305C408.349 313.632 411.162 328.453 409.314 341.557C408.742 345.635 407.776 349.648 406.796 353.644C406.622 354.357 407.726 354.663 407.9 353.948C409.668 346.731 411.264 339.452 410.963 331.982C410.696 325.171 409.123 318.366 405.885 312.344C404.128 309.041 401.835 306.05 399.101 303.492C398.716 303.137 398.17 303.409 398.124 303.895L396.98 316.147C396.941 316.374 396.92 316.605 396.915 316.835C396.921 316.951 396.946 317.066 396.988 317.174C397.22 317.815 397.632 318.436 397.931 319.051C398.943 321.094 399.824 323.201 400.566 325.357C401.821 329.075 402.444 332.933 402.234 336.859C401.968 341.851 400.541 346.724 399.012 351.456L399.411 351.058C398.357 351.382 397.307 351.74 396.288 352.161C395.75 352.383 395.109 352.606 394.683 353.017C394.014 353.673 394.042 354.932 393 355.213C392.09 355.46 391.158 354.785 390.24 354.727C389.696 354.694 389.369 354.763 388.981 355.155C388.656 355.487 388.425 355.9 388.312 356.35C387.829 358.269 389.139 359.969 390.757 360.813C392.914 361.941 395.371 362.11 397.445 360.682C398.048 360.268 397.476 359.278 396.873 359.696L396.865 359.703Z",
  fill: "#2A6EBF"
});

var _ref104 = /*#__PURE__*/React.createElement("path", {
  d: "M407.362 353.76C408.019 356.352 407.899 359.211 406.615 361.559C405.33 363.907 402.775 365.624 400.096 365.523C401.137 364.585 402.125 363.59 403.055 362.542C404.462 360.936 404.771 358.374 404.771 358.374C404.342 362.178 401.086 365.482 397.277 365.962C396.834 366.019 396.236 365.93 396.168 365.489C396.168 365.489 398.094 364.348 399.124 362.872C400.153 361.395 401.456 357.945 401.456 357.945C401.139 359.569 400.461 361.102 399.473 362.431C398.705 363.461 397.724 364.375 396.524 364.84C395.324 365.305 393.879 365.259 392.83 364.516C391.78 363.773 391.257 362.27 391.829 361.119L394.062 361.696",
  fill: "#29ABE2"
});

var _ref105 = /*#__PURE__*/React.createElement("path", {
  d: "M406.81 353.911C407.437 356.479 407.335 359.331 405.908 361.636C404.671 363.633 402.476 365.001 400.096 364.953L400.501 365.927C401.756 364.811 403.138 363.59 404.042 362.168C404.747 361.013 405.192 359.718 405.347 358.374H404.203C403.966 360.266 402.992 362.001 401.603 363.291C400.926 363.919 400.149 364.431 399.304 364.807C399.018 364.931 396.861 365.748 396.73 365.332L396.466 365.977C397.945 365.092 399.269 363.881 400.113 362.361C400.846 360.988 401.481 359.565 402.012 358.103L400.908 357.799C400.414 360.197 399.099 362.85 396.854 364.067C395.839 364.616 394.546 364.791 393.486 364.251C392.494 363.746 391.86 362.479 392.331 361.412L391.684 361.669L393.919 362.24C394.635 362.425 394.938 361.324 394.224 361.138L391.989 360.561C391.767 360.502 391.444 360.594 391.342 360.823C391.071 361.436 390.988 362.116 391.104 362.776C391.22 363.436 391.53 364.047 391.995 364.532C393.017 365.626 394.649 365.894 396.062 365.573C399.351 364.827 401.386 361.126 402.012 358.092C402.163 357.364 401.167 357.105 400.908 357.788C400.425 359.103 399.856 360.385 399.205 361.626C398.439 363.053 397.267 364.158 395.883 364.991C395.775 365.056 395.691 365.153 395.643 365.27C395.596 365.386 395.588 365.514 395.62 365.636C396.016 366.834 397.468 366.564 398.421 366.318C399.621 365.998 400.742 365.44 401.719 364.676C402.711 363.916 403.543 362.969 404.165 361.887C404.788 360.805 405.19 359.611 405.347 358.374C405.439 357.647 404.295 357.661 404.203 358.374C404.228 358.177 404.162 358.597 404.148 358.674C404.094 358.941 404.032 359.205 403.96 359.467C403.752 360.285 403.407 361.061 402.939 361.765C402.07 363.011 400.828 364.11 399.691 365.119C399.308 365.46 399.624 366.084 400.096 366.094C402.813 366.149 405.312 364.62 406.782 362.385C408.478 359.818 408.625 356.521 407.914 353.602C407.74 352.888 406.636 353.191 406.81 353.905V353.911Z",
  fill: "#2A6EBF"
});

var _ref106 = /*#__PURE__*/React.createElement("path", {
  d: "M404.62 312.613C402.074 308.866 401.023 305.332 398.31 303.241C397.177 302.368 394.645 313.719 396.993 317.028C398.943 319.778 402.67 324.216 402.67 324.216L404.62 312.613Z",
  fill: "#29ABE2"
});

var _ref107 = /*#__PURE__*/React.createElement("path", {
  d: "M310.617 361.154C310.433 361.009 310.2 360.938 309.965 360.957C309.731 360.976 309.512 361.082 309.353 361.255L308.824 360.197C309.547 360.707 310.385 361.03 311.264 361.138C312.142 361.245 313.034 361.134 313.859 360.813C315.497 360.157 316.751 358.878 317.067 357.146C317.237 356.216 317.164 356.119 315.804 355.276C314.677 355.169 315.118 355.363 314.394 355.648C313.67 355.934 312.785 355.934 312.176 355.453C311.567 354.972 311.379 354.186 310.989 353.537C310.599 352.888 306.413 351.609 306.413 351.609C301.815 337.411 301.639 330.146 308.498 316.881L307.284 303.901C300.479 310.163 296.825 319.306 295.843 328.49C294.86 337.675 296.431 344.821 298.631 353.791",
  fill: "#29ABE2"
});

var _ref108 = /*#__PURE__*/React.createElement("path", {
  d: "M310.906 360.662C310.609 360.46 310.25 360.368 309.893 360.402C309.535 360.437 309.2 360.596 308.948 360.852L309.848 360.967L309.319 359.909L308.535 360.689C309.446 361.312 310.513 361.671 311.616 361.727C312.719 361.783 313.817 361.534 314.787 361.007C316.339 360.171 317.811 358.396 317.703 356.53C317.656 355.738 316.927 355.286 316.309 354.917C315.645 354.522 315.022 354.647 314.41 355.004C314.182 355.139 313.928 355.226 313.664 355.258C313.401 355.291 313.134 355.268 312.88 355.192C312.239 354.965 312 354.266 311.727 353.708C311.425 353.092 311.069 352.794 310.457 352.496C309.22 351.896 307.883 351.462 306.57 351.058L306.969 351.456C305.587 347.177 304.295 342.807 303.857 338.319C303.483 334.499 303.841 330.642 304.912 326.956C305.552 324.792 306.35 322.678 307.299 320.631C307.811 319.509 308.443 318.426 308.927 317.293C309.033 317.082 309.072 316.843 309.04 316.609C308.888 314.416 308.631 312.225 308.426 310.039L307.854 303.896C307.808 303.408 307.261 303.138 306.877 303.492C296.611 313.013 293.68 328.101 295.511 341.49C296.083 345.694 297.071 349.826 298.085 353.942C298.26 354.656 299.364 354.353 299.189 353.639C297.473 346.604 295.9 339.518 296.156 332.232C296.385 325.582 297.891 318.918 301.03 313.02C302.746 309.763 304.996 306.815 307.688 304.299L306.711 303.901L307.557 312.946L307.787 315.412C307.827 315.84 307.97 316.371 307.917 316.794C307.888 317.022 307.622 317.348 307.462 317.669C307.028 318.531 306.612 319.402 306.214 320.282C305.537 321.779 304.912 323.303 304.379 324.856C302.494 330.346 302.151 335.986 303.188 341.691C303.808 345.022 304.675 348.302 305.782 351.505C305.925 351.933 306.068 352.087 306.461 352.218C306.832 352.343 307.206 352.459 307.577 352.586C308.479 352.894 309.596 353.171 310.373 353.747C310.774 354.045 310.936 354.803 311.271 355.292C311.476 355.604 311.751 355.867 312.073 356.058C312.395 356.25 312.756 356.366 313.13 356.399C313.537 356.432 313.948 356.388 314.338 356.267C314.639 356.175 314.873 355.972 315.151 355.864C315.472 355.738 316.302 356.065 316.508 356.466C316.714 356.866 316.312 357.784 316.117 358.153C315.732 358.864 315.16 359.456 314.461 359.865C313.65 360.362 312.71 360.611 311.758 360.581C310.806 360.55 309.884 360.243 309.105 359.695C308.599 359.345 308.089 360.007 308.323 360.477L308.852 361.535C309.023 361.876 309.499 361.889 309.75 361.651C309.945 361.468 310.121 361.508 310.322 361.639C310.935 362.053 311.507 361.069 310.895 360.653L310.906 360.662Z",
  fill: "#2A6EBF"
});

var _ref109 = /*#__PURE__*/React.createElement("path", {
  d: "M298.617 353.76C297.961 356.352 298.081 359.211 299.365 361.559C300.649 363.907 303.205 365.624 305.883 365.52C304.842 364.582 303.854 363.587 302.925 362.539C301.517 360.933 301.208 358.371 301.208 358.371C301.637 362.175 304.894 365.479 308.702 365.96C309.145 366.017 309.743 365.927 309.812 365.486C309.812 365.486 307.886 364.345 306.856 362.869C305.826 361.392 304.523 357.942 304.523 357.942C304.841 359.566 305.519 361.099 306.507 362.428C307.275 363.458 308.255 364.372 309.456 364.837C310.657 365.302 312.1 365.256 313.15 364.513C314.199 363.77 314.723 362.267 314.151 361.116L311.155 361.441",
  fill: "#29ABE2"
});

var _ref110 = /*#__PURE__*/React.createElement("path", {
  d: "M298.065 353.607C297.35 356.527 297.5 359.816 299.198 362.391C300.668 364.62 303.172 366.149 305.883 366.099C306.354 366.089 306.671 365.466 306.288 365.125C305.154 364.117 303.903 363.02 303.04 361.77C302.574 361.066 302.229 360.29 302.019 359.472C301.948 359.21 301.885 358.946 301.832 358.679C301.819 358.612 301.75 358.173 301.776 358.38C301.685 357.667 300.54 357.651 300.632 358.38C300.789 359.618 301.19 360.813 301.813 361.896C302.435 362.979 303.267 363.927 304.26 364.687C305.21 365.43 306.298 365.978 307.461 366.302C308.427 366.566 309.952 366.872 310.36 365.647C310.392 365.526 310.383 365.397 310.336 365.281C310.288 365.165 310.204 365.067 310.096 365.002C308.712 364.169 307.541 363.063 306.774 361.638C306.123 360.397 305.554 359.115 305.071 357.799C305.031 357.653 304.934 357.529 304.802 357.454C304.67 357.38 304.513 357.36 304.367 357.401C304.22 357.441 304.096 357.538 304.021 357.669C303.946 357.801 303.927 357.957 303.967 358.103C304.595 361.147 306.628 364.826 309.918 365.584C311.325 365.91 312.968 365.636 313.985 364.543C314.449 364.058 314.758 363.447 314.874 362.787C314.99 362.127 314.908 361.448 314.637 360.835C314.588 360.747 314.516 360.674 314.429 360.624C314.342 360.573 314.243 360.548 314.142 360.549L311.146 360.875C310.421 360.954 310.414 362.097 311.146 362.016L314.142 361.69L313.649 361.405C314.119 362.472 313.486 363.739 312.493 364.244C311.434 364.783 310.141 364.609 309.125 364.06C306.88 362.843 305.566 360.19 305.071 357.792L303.967 358.103C304.499 359.565 305.135 360.988 305.869 362.361C306.71 363.881 308.034 365.089 309.519 365.982L309.256 365.338C309.113 365.754 306.953 364.935 306.681 364.813C305.836 364.435 305.059 363.921 304.382 363.291C302.993 362.007 302.018 360.265 301.782 358.374H300.638C300.793 359.718 301.238 361.012 301.943 362.168C302.847 363.595 304.232 364.811 305.484 365.927L305.883 364.95C303.505 364.998 301.307 363.626 300.071 361.633C298.641 359.333 298.543 356.477 299.169 353.908C299.343 353.195 298.239 352.89 298.065 353.604V353.607Z",
  fill: "#2A6EBF"
});

var _ref111 = /*#__PURE__*/React.createElement("path", {
  d: "M301.36 312.613C303.906 308.866 304.957 305.332 307.67 303.241C308.802 302.368 311.335 313.719 308.987 317.028C307.036 319.778 303.309 324.216 303.309 324.216L301.36 312.613Z",
  fill: "#29ABE2"
});

var _ref112 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M219.545 69H199.416V84.6939H184.318V153.075H160.414V206.883H131.477V384H290V206.883H259.805V153.075H235.901V84.6939H219.545V69Z",
  fill: "#F7FAFF"
});

var _ref113 = /*#__PURE__*/React.createElement("rect", {
  x: 177.3,
  y: 221.935,
  width: 13.623,
  height: 12.5543,
  fill: "white"
});

var _ref114 = /*#__PURE__*/React.createElement("rect", {
  x: 177.3,
  y: 221.935,
  width: 13.623,
  height: 12.5543,
  fill: "white"
});

var _ref115 = /*#__PURE__*/React.createElement("rect", {
  x: 177.3,
  y: 221.935,
  width: 13.623,
  height: 12.5543,
  fill: "white"
});

var _ref116 = /*#__PURE__*/React.createElement("rect", {
  x: 202.069,
  y: 221.935,
  width: 13.623,
  height: 12.5543,
  fill: "white"
});

var _ref117 = /*#__PURE__*/React.createElement("rect", {
  x: 202.069,
  y: 221.935,
  width: 13.623,
  height: 12.5543,
  fill: "white"
});

var _ref118 = /*#__PURE__*/React.createElement("rect", {
  x: 202.069,
  y: 221.935,
  width: 13.623,
  height: 12.5543,
  fill: "white"
});

var _ref119 = /*#__PURE__*/React.createElement("rect", {
  x: 228.077,
  y: 221.935,
  width: 13.623,
  height: 12.5543,
  fill: "white"
});

var _ref120 = /*#__PURE__*/React.createElement("rect", {
  x: 228.077,
  y: 221.935,
  width: 13.623,
  height: 12.5543,
  fill: "white"
});

var _ref121 = /*#__PURE__*/React.createElement("rect", {
  x: 228.077,
  y: 221.935,
  width: 13.623,
  height: 12.5543,
  fill: "white"
});

var _ref122 = /*#__PURE__*/React.createElement("rect", {
  x: 177.3,
  y: 244.761,
  width: 13.623,
  height: 12.5543,
  fill: "white"
});

var _ref123 = /*#__PURE__*/React.createElement("rect", {
  x: 177.3,
  y: 244.761,
  width: 13.623,
  height: 12.5543,
  fill: "white"
});

var _ref124 = /*#__PURE__*/React.createElement("rect", {
  x: 177.3,
  y: 244.761,
  width: 13.623,
  height: 12.5543,
  fill: "white"
});

var _ref125 = /*#__PURE__*/React.createElement("rect", {
  x: 202.069,
  y: 244.761,
  width: 13.623,
  height: 12.5543,
  fill: "white"
});

var _ref126 = /*#__PURE__*/React.createElement("rect", {
  x: 202.069,
  y: 244.761,
  width: 13.623,
  height: 12.5543,
  fill: "white"
});

var _ref127 = /*#__PURE__*/React.createElement("rect", {
  x: 202.069,
  y: 244.761,
  width: 13.623,
  height: 12.5543,
  fill: "white"
});

var _ref128 = /*#__PURE__*/React.createElement("rect", {
  x: 228.077,
  y: 244.761,
  width: 13.623,
  height: 12.5543,
  fill: "white"
});

var _ref129 = /*#__PURE__*/React.createElement("rect", {
  x: 228.077,
  y: 244.761,
  width: 13.623,
  height: 12.5543,
  fill: "white"
});

var _ref130 = /*#__PURE__*/React.createElement("rect", {
  x: 228.077,
  y: 244.761,
  width: 13.623,
  height: 12.5543,
  fill: "white"
});

var _ref131 = /*#__PURE__*/React.createElement("rect", {
  x: 177.3,
  y: 176.283,
  width: 13.623,
  height: 12.5543,
  fill: "white"
});

var _ref132 = /*#__PURE__*/React.createElement("rect", {
  x: 177.3,
  y: 176.283,
  width: 13.623,
  height: 12.5543,
  fill: "white"
});

var _ref133 = /*#__PURE__*/React.createElement("rect", {
  x: 177.3,
  y: 176.283,
  width: 13.623,
  height: 12.5543,
  fill: "white"
});

var _ref134 = /*#__PURE__*/React.createElement("rect", {
  x: 202.07,
  y: 176.283,
  width: 13.623,
  height: 12.5543,
  fill: "white"
});

var _ref135 = /*#__PURE__*/React.createElement("rect", {
  x: 202.07,
  y: 176.283,
  width: 13.623,
  height: 12.5543,
  fill: "white"
});

var _ref136 = /*#__PURE__*/React.createElement("rect", {
  x: 202.07,
  y: 176.283,
  width: 13.623,
  height: 12.5543,
  fill: "white"
});

var _ref137 = /*#__PURE__*/React.createElement("rect", {
  x: 228.077,
  y: 176.283,
  width: 13.623,
  height: 12.5543,
  fill: "white"
});

var _ref138 = /*#__PURE__*/React.createElement("rect", {
  x: 228.077,
  y: 176.283,
  width: 13.623,
  height: 12.5543,
  fill: "white"
});

var _ref139 = /*#__PURE__*/React.createElement("rect", {
  x: 228.077,
  y: 176.283,
  width: 13.623,
  height: 12.5543,
  fill: "white"
});

var _ref140 = /*#__PURE__*/React.createElement("rect", {
  x: 177.3,
  y: 199.109,
  width: 13.623,
  height: 12.5543,
  fill: "white"
});

var _ref141 = /*#__PURE__*/React.createElement("rect", {
  x: 177.3,
  y: 199.109,
  width: 13.623,
  height: 12.5543,
  fill: "white"
});

var _ref142 = /*#__PURE__*/React.createElement("rect", {
  x: 177.3,
  y: 199.109,
  width: 13.623,
  height: 12.5543,
  fill: "white"
});

var _ref143 = /*#__PURE__*/React.createElement("rect", {
  x: 202.069,
  y: 199.109,
  width: 13.623,
  height: 12.5543,
  fill: "white"
});

var _ref144 = /*#__PURE__*/React.createElement("rect", {
  x: 202.069,
  y: 199.109,
  width: 13.623,
  height: 12.5543,
  fill: "white"
});

var _ref145 = /*#__PURE__*/React.createElement("rect", {
  x: 202.069,
  y: 199.109,
  width: 13.623,
  height: 12.5543,
  fill: "white"
});

var _ref146 = /*#__PURE__*/React.createElement("rect", {
  x: 228.077,
  y: 199.109,
  width: 13.623,
  height: 12.5543,
  fill: "white"
});

var _ref147 = /*#__PURE__*/React.createElement("rect", {
  x: 228.077,
  y: 199.109,
  width: 13.623,
  height: 12.5543,
  fill: "white"
});

var _ref148 = /*#__PURE__*/React.createElement("rect", {
  x: 228.077,
  y: 199.109,
  width: 13.623,
  height: 12.5543,
  fill: "white"
});

var _ref149 = /*#__PURE__*/React.createElement("rect", {
  x: 177.3,
  y: 267.587,
  width: 13.623,
  height: 12.5543,
  fill: "white"
});

var _ref150 = /*#__PURE__*/React.createElement("rect", {
  x: 177.3,
  y: 267.587,
  width: 13.623,
  height: 12.5543,
  fill: "white"
});

var _ref151 = /*#__PURE__*/React.createElement("rect", {
  x: 177.3,
  y: 267.587,
  width: 13.623,
  height: 12.5543,
  fill: "white"
});

var _ref152 = /*#__PURE__*/React.createElement("rect", {
  x: 202.069,
  y: 267.587,
  width: 13.623,
  height: 12.5543,
  fill: "white"
});

var _ref153 = /*#__PURE__*/React.createElement("rect", {
  x: 202.069,
  y: 267.587,
  width: 13.623,
  height: 12.5543,
  fill: "white"
});

var _ref154 = /*#__PURE__*/React.createElement("rect", {
  x: 202.069,
  y: 267.587,
  width: 13.623,
  height: 12.5543,
  fill: "white"
});

var _ref155 = /*#__PURE__*/React.createElement("rect", {
  x: 228.077,
  y: 267.587,
  width: 13.623,
  height: 12.5543,
  fill: "white"
});

var _ref156 = /*#__PURE__*/React.createElement("rect", {
  x: 228.077,
  y: 267.587,
  width: 13.623,
  height: 12.5543,
  fill: "white"
});

var _ref157 = /*#__PURE__*/React.createElement("rect", {
  x: 228.077,
  y: 267.587,
  width: 13.623,
  height: 12.5543,
  fill: "white"
});

var _ref158 = /*#__PURE__*/React.createElement("rect", {
  x: 177.3,
  y: 290.413,
  width: 13.623,
  height: 12.5543,
  fill: "white"
});

var _ref159 = /*#__PURE__*/React.createElement("rect", {
  x: 177.3,
  y: 290.413,
  width: 13.623,
  height: 12.5543,
  fill: "white"
});

var _ref160 = /*#__PURE__*/React.createElement("rect", {
  x: 177.3,
  y: 290.413,
  width: 13.623,
  height: 12.5543,
  fill: "white"
});

var _ref161 = /*#__PURE__*/React.createElement("rect", {
  x: 202.069,
  y: 290.413,
  width: 13.623,
  height: 12.5543,
  fill: "white"
});

var _ref162 = /*#__PURE__*/React.createElement("rect", {
  x: 202.069,
  y: 290.413,
  width: 13.623,
  height: 12.5543,
  fill: "white"
});

var _ref163 = /*#__PURE__*/React.createElement("rect", {
  x: 202.069,
  y: 290.413,
  width: 13.623,
  height: 12.5543,
  fill: "white"
});

var _ref164 = /*#__PURE__*/React.createElement("rect", {
  x: 228.077,
  y: 290.413,
  width: 13.623,
  height: 12.5543,
  fill: "white"
});

var _ref165 = /*#__PURE__*/React.createElement("rect", {
  x: 228.077,
  y: 290.413,
  width: 13.623,
  height: 12.5543,
  fill: "white"
});

var _ref166 = /*#__PURE__*/React.createElement("rect", {
  x: 228.077,
  y: 290.413,
  width: 13.623,
  height: 12.5543,
  fill: "white"
});

var _ref167 = /*#__PURE__*/React.createElement("rect", {
  x: 177.3,
  y: 312.098,
  width: 13.623,
  height: 12.5543,
  fill: "white"
});

var _ref168 = /*#__PURE__*/React.createElement("rect", {
  x: 177.3,
  y: 312.098,
  width: 13.623,
  height: 12.5543,
  fill: "white"
});

var _ref169 = /*#__PURE__*/React.createElement("rect", {
  x: 177.3,
  y: 312.098,
  width: 13.623,
  height: 12.5543,
  fill: "white"
});

var _ref170 = /*#__PURE__*/React.createElement("rect", {
  x: 202.069,
  y: 312.098,
  width: 13.623,
  height: 12.5543,
  fill: "white"
});

var _ref171 = /*#__PURE__*/React.createElement("rect", {
  x: 202.069,
  y: 312.098,
  width: 13.623,
  height: 12.5543,
  fill: "white"
});

var _ref172 = /*#__PURE__*/React.createElement("rect", {
  x: 202.069,
  y: 312.098,
  width: 13.623,
  height: 12.5543,
  fill: "white"
});

var _ref173 = /*#__PURE__*/React.createElement("rect", {
  x: 228.077,
  y: 312.098,
  width: 13.623,
  height: 12.5543,
  fill: "white"
});

var _ref174 = /*#__PURE__*/React.createElement("rect", {
  x: 228.077,
  y: 312.098,
  width: 13.623,
  height: 12.5543,
  fill: "white"
});

var _ref175 = /*#__PURE__*/React.createElement("rect", {
  x: 228.077,
  y: 312.098,
  width: 13.623,
  height: 12.5543,
  fill: "white"
});

var _ref176 = /*#__PURE__*/React.createElement("rect", {
  x: 177.3,
  y: 334.924,
  width: 13.623,
  height: 12.5543,
  fill: "white"
});

var _ref177 = /*#__PURE__*/React.createElement("rect", {
  x: 177.3,
  y: 334.924,
  width: 13.623,
  height: 12.5543,
  fill: "white"
});

var _ref178 = /*#__PURE__*/React.createElement("rect", {
  x: 177.3,
  y: 334.924,
  width: 13.623,
  height: 12.5543,
  fill: "white"
});

var _ref179 = /*#__PURE__*/React.createElement("rect", {
  x: 202.069,
  y: 334.924,
  width: 13.623,
  height: 12.5543,
  fill: "white"
});

var _ref180 = /*#__PURE__*/React.createElement("rect", {
  x: 202.069,
  y: 334.924,
  width: 13.623,
  height: 12.5543,
  fill: "white"
});

var _ref181 = /*#__PURE__*/React.createElement("rect", {
  x: 202.069,
  y: 334.924,
  width: 13.623,
  height: 12.5543,
  fill: "white"
});

var _ref182 = /*#__PURE__*/React.createElement("rect", {
  x: 228.077,
  y: 334.924,
  width: 13.623,
  height: 12.5543,
  fill: "white"
});

var _ref183 = /*#__PURE__*/React.createElement("rect", {
  x: 228.077,
  y: 334.924,
  width: 13.623,
  height: 12.5543,
  fill: "white"
});

var _ref184 = /*#__PURE__*/React.createElement("rect", {
  x: 228.077,
  y: 334.924,
  width: 13.623,
  height: 12.5543,
  fill: "white"
});

var _ref185 = /*#__PURE__*/React.createElement("rect", {
  x: 177.3,
  y: 356.609,
  width: 13.623,
  height: 12.5543,
  fill: "white"
});

var _ref186 = /*#__PURE__*/React.createElement("rect", {
  x: 177.3,
  y: 356.609,
  width: 13.623,
  height: 12.5543,
  fill: "white"
});

var _ref187 = /*#__PURE__*/React.createElement("rect", {
  x: 177.3,
  y: 356.609,
  width: 13.623,
  height: 12.5543,
  fill: "white"
});

var _ref188 = /*#__PURE__*/React.createElement("rect", {
  x: 202.069,
  y: 356.609,
  width: 13.623,
  height: 12.5543,
  fill: "white"
});

var _ref189 = /*#__PURE__*/React.createElement("rect", {
  x: 202.069,
  y: 356.609,
  width: 13.623,
  height: 12.5543,
  fill: "white"
});

var _ref190 = /*#__PURE__*/React.createElement("rect", {
  x: 202.069,
  y: 356.609,
  width: 13.623,
  height: 12.5543,
  fill: "white"
});

var _ref191 = /*#__PURE__*/React.createElement("rect", {
  x: 228.077,
  y: 356.609,
  width: 13.623,
  height: 12.5543,
  fill: "white"
});

var _ref192 = /*#__PURE__*/React.createElement("rect", {
  x: 228.077,
  y: 356.609,
  width: 13.623,
  height: 12.5543,
  fill: "white"
});

var _ref193 = /*#__PURE__*/React.createElement("rect", {
  x: 228.077,
  y: 356.609,
  width: 13.623,
  height: 12.5543,
  fill: "white"
});

var _ref194 = /*#__PURE__*/React.createElement("rect", {
  x: 128.5,
  y: 31.5,
  width: 289,
  height: 356,
  stroke: "#2A6EBF",
  strokeWidth: 5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref195 = /*#__PURE__*/React.createElement("line", {
  x1: 273.5,
  y1: 33,
  x2: 273.5,
  y2: 182,
  stroke: "#2A6EBF",
  strokeWidth: 5
});

var _ref196 = /*#__PURE__*/React.createElement("line", {
  x1: 273.5,
  y1: 190,
  x2: 273.5,
  y2: 386,
  stroke: "#2A6EBF",
  strokeWidth: 5
});

var _ref197 = /*#__PURE__*/React.createElement("line", {
  x1: 130,
  y1: 179.5,
  x2: 415,
  y2: 179.5,
  stroke: "#2A6EBF",
  strokeWidth: 5
});

var _ref198 = /*#__PURE__*/React.createElement("line", {
  x1: 130,
  y1: 189.5,
  x2: 415,
  y2: 189.5,
  stroke: "#2A6EBF",
  strokeWidth: 5
});

var _ref199 = /*#__PURE__*/React.createElement("line", {
  x1: 178.381,
  y1: 43.6932,
  x2: 198.693,
  y2: 56.6195,
  stroke: "#2A6EBF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref200 = /*#__PURE__*/React.createElement("line", {
  x1: 220.381,
  y1: 84.6932,
  x2: 240.693,
  y2: 97.6195,
  stroke: "#2A6EBF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref201 = /*#__PURE__*/React.createElement("line", {
  x1: 189.381,
  y1: 149.693,
  x2: 209.693,
  y2: 162.619,
  stroke: "#2A6EBF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref202 = /*#__PURE__*/React.createElement("line", {
  x1: 178.368,
  y1: 90.643,
  x2: 205.643,
  y2: 106.632,
  stroke: "#2A6EBF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref203 = /*#__PURE__*/React.createElement("line", {
  x1: 147.414,
  y1: 90.9768,
  x2: 176.977,
  y2: 119.586,
  stroke: "#2A6EBF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref204 = /*#__PURE__*/React.createElement("line", {
  x1: 190.788,
  y1: 199.914,
  x2: 206.4,
  y2: 218.243,
  stroke: "#2A6EBF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref205 = /*#__PURE__*/React.createElement("line", {
  x1: 218.87,
  y1: 251.454,
  x2: 234.482,
  y2: 269.784,
  stroke: "#2A6EBF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref206 = /*#__PURE__*/React.createElement("line", {
  x1: 235.409,
  y1: 214.113,
  x2: 251.021,
  y2: 232.442,
  stroke: "#2A6EBF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref207 = /*#__PURE__*/React.createElement("line", {
  x1: 162.409,
  y1: 343.113,
  x2: 178.021,
  y2: 361.442,
  stroke: "#2A6EBF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref208 = /*#__PURE__*/React.createElement("line", {
  x1: 214.409,
  y1: 314.113,
  x2: 230.021,
  y2: 332.442,
  stroke: "#2A6EBF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref209 = /*#__PURE__*/React.createElement("line", {
  x1: 292.409,
  y1: 209.113,
  x2: 308.021,
  y2: 227.442,
  stroke: "#2A6EBF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref210 = /*#__PURE__*/React.createElement("line", {
  x1: 288.409,
  y1: 229.113,
  x2: 304.021,
  y2: 247.442,
  stroke: "#2A6EBF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref211 = /*#__PURE__*/React.createElement("line", {
  x1: 332.41,
  y1: 200.113,
  x2: 348.022,
  y2: 218.442,
  stroke: "#2A6EBF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref212 = /*#__PURE__*/React.createElement("line", {
  x1: 170.122,
  y1: 304.46,
  x2: 185.734,
  y2: 322.789,
  stroke: "#2A6EBF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref213 = /*#__PURE__*/React.createElement("line", {
  x1: 176.966,
  y1: 244.783,
  x2: 198.331,
  y2: 268.087,
  stroke: "#2A6EBF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref214 = /*#__PURE__*/React.createElement("line", {
  x1: 377.413,
  y1: 214.061,
  x2: 398.778,
  y2: 237.365,
  stroke: "#2A6EBF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref215 = /*#__PURE__*/React.createElement("line", {
  x1: 147.283,
  y1: 235.997,
  x2: 167.123,
  y2: 272.036,
  stroke: "#2A6EBF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref216 = /*#__PURE__*/React.createElement("line", {
  x1: 326.937,
  y1: 44.3169,
  x2: 348.027,
  y2: 55.9314,
  stroke: "#2A6EBF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref217 = /*#__PURE__*/React.createElement("line", {
  x1: 369.381,
  y1: 84.6932,
  x2: 389.693,
  y2: 97.6195,
  stroke: "#2A6EBF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref218 = /*#__PURE__*/React.createElement("line", {
  x1: 338.381,
  y1: 149.693,
  x2: 358.693,
  y2: 162.619,
  stroke: "#2A6EBF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref219 = /*#__PURE__*/React.createElement("line", {
  x1: 340.368,
  y1: 111.643,
  x2: 367.643,
  y2: 127.632,
  stroke: "#2A6EBF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref220 = /*#__PURE__*/React.createElement("line", {
  x1: 293.373,
  y1: 94.5646,
  x2: 328.656,
  y2: 115.72,
  stroke: "#2A6EBF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref221 = /*#__PURE__*/React.createElement("path", {
  d: "M83.7328 347.034C68.058 349.628 65.2223 357.648 68.8396 363.293L60.0361 365.102C59.6281 362.555 60.6252 356.072 67.8771 350.522C75.1289 344.972 81.4692 345.884 83.7328 347.034Z",
  fill: "#A5DFB8"
});

var _ref222 = /*#__PURE__*/React.createElement("path", {
  d: "M57.8293 347.291C57.8293 355.672 54.3944 361.064 55.8971 363.818H49.6713V355.85C49.6713 357.62 51.26 351.423 55.0384 343.159C58.8168 334.895 64.7707 334.993 67.2754 336.075C66.2735 337.059 57.8293 336.717 57.8293 347.291Z",
  fill: "#A5DFB8"
});

var _ref223 = /*#__PURE__*/React.createElement("path", {
  d: "M84.4163 356.162C75.7069 353.012 70.4411 359.946 68.8969 363.806L62.6428 360.332C63.3377 357.475 66.3953 351.437 73.0663 350.14C79.7373 348.843 83.4126 353.614 84.4163 356.162Z",
  fill: "#5DC898"
});

var _ref224 = /*#__PURE__*/React.createElement("path", {
  d: "M21.8754 362.388C32.8683 357.494 35.6258 364.93 36.9184 367.524L40.1005 365.19C39.5189 363.27 36.9596 359.213 31.3757 358.342C25.7919 357.47 22.7156 360.676 21.8754 362.388Z",
  fill: "#A5DFB8"
});

var _ref225 = /*#__PURE__*/React.createElement("path", {
  d: "M26.504 347.956C33.8808 349.939 40.9202 360.605 40.8238 364.842C43.572 366.28 48.6635 368.294 47.0434 364.842C45.4234 361.39 42.2781 356.318 40.8238 354.452C35.7612 347.956 29.5897 346.908 26.504 347.956Z",
  fill: "#A5DFB8"
});

var _ref226 = /*#__PURE__*/React.createElement("path", {
  d: "M78.0483 344.643C58.825 344.643 57.2865 356.361 63.3264 366.051L52.6204 366.598C51.4485 362.54 51.0487 352.735 58.825 345.985C66.6013 339.234 74.8807 342.278 78.0483 344.643Z",
  fill: "#5DC898"
});

var _ref227 = /*#__PURE__*/React.createElement("path", {
  d: "M14 359.363C31.6041 349.643 36.0199 364.412 38.0898 369.564L43.1857 364.927C42.2543 361.115 38.1558 353.057 29.2138 351.326C20.2718 349.595 15.3455 355.963 14 359.363Z",
  fill: "#5DC898"
});

var _ref228 = /*#__PURE__*/React.createElement("path", {
  d: "M21.4122 330.699C33.2255 334.637 44.4983 355.82 44.3439 364.236C48.7449 367.093 56.8984 371.093 54.3041 364.236C51.7098 357.38 46.6729 347.306 44.3439 343.6C36.2368 330.699 26.3537 328.618 21.4122 330.699Z",
  fill: "#5DC898"
});

var _ref229 = /*#__PURE__*/React.createElement("path", {
  d: "M36.7344 397L29 367H74L65.3281 397H36.7344Z",
  fill: "#F8D4B2",
  stroke: "#EF7249",
  strokeWidth: 4
});

var _ref230 = /*#__PURE__*/React.createElement("line", {
  x1: 36,
  y1: 399.5,
  x2: 42,
  y2: 399.5,
  stroke: "#EF7249",
  strokeWidth: 5
});

var _ref231 = /*#__PURE__*/React.createElement("line", {
  x1: 60,
  y1: 399.5,
  x2: 66,
  y2: 399.5,
  stroke: "#EF7249",
  strokeWidth: 5
});

var _ref232 = /*#__PURE__*/React.createElement("rect", {
  x: 21.4124,
  y: 359.649,
  width: 58.3714,
  height: 8.33878,
  fill: "#EF7249"
});

var SvgSurveyNominationError = function SvgSurveyNominationError(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 537,
    height: 420,
    viewBox: "0 0 537 420",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, _ref92, _ref93, _ref94, _ref95, _ref96, _ref97, _ref98, _ref99, _ref100, _ref101, _ref102, _ref103, _ref104, _ref105, _ref106, _ref107, _ref108, _ref109, _ref110, _ref111, _ref112, _ref113, _ref114, _ref115, _ref116, _ref117, _ref118, _ref119, _ref120, _ref121, _ref122, _ref123, _ref124, _ref125, _ref126, _ref127, _ref128, _ref129, _ref130, _ref131, _ref132, _ref133, _ref134, _ref135, _ref136, _ref137, _ref138, _ref139, _ref140, _ref141, _ref142, _ref143, _ref144, _ref145, _ref146, _ref147, _ref148, _ref149, _ref150, _ref151, _ref152, _ref153, _ref154, _ref155, _ref156, _ref157, _ref158, _ref159, _ref160, _ref161, _ref162, _ref163, _ref164, _ref165, _ref166, _ref167, _ref168, _ref169, _ref170, _ref171, _ref172, _ref173, _ref174, _ref175, _ref176, _ref177, _ref178, _ref179, _ref180, _ref181, _ref182, _ref183, _ref184, _ref185, _ref186, _ref187, _ref188, _ref189, _ref190, _ref191, _ref192, _ref193, _ref194, _ref195, _ref196, _ref197, _ref198, _ref199, _ref200, _ref201, _ref202, _ref203, _ref204, _ref205, _ref206, _ref207, _ref208, _ref209, _ref210, _ref211, _ref212, _ref213, _ref214, _ref215, _ref216, _ref217, _ref218, _ref219, _ref220, _ref221, _ref222, _ref223, _ref224, _ref225, _ref226, _ref227, _ref228, _ref229, _ref230, _ref231, _ref232);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSurveyNominationError, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/SurveyNominationError.6cb39970.svg";
export { ForwardRef as ReactComponent };